import { ChangeDetectionStrategy, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { cardF } from '@atmi/core/models';
import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IseFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IseFormComponent),
    },
  ],
  selector: 'app-ise-form',
  styleUrls: ['./ise-form.component.scss'],
  templateUrl: './ise-form.component.html',
})
export class IseFormComponent extends BaseCtrlValueAccessorFormArrayComponent<cardF.ISE> implements OnDestroy, OnInit {

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage ISE without a control');
    }

    const control = this.formManager.makeForm(cardF.ISEMeta, {} as cardF.ISE);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage ISE without a control');
    }

    this.form.removeAt(index);
  }
}
